'use client';

import Image from 'next/image';
import { ComponentProps, SyntheticEvent, useState } from 'react';

import { PATH } from '@/shared/constants';

interface ArticleItemImageProps extends ComponentProps<'img'> {
  src: string;
  alt?: string;
  priority?: boolean;
  loading?: 'eager' | 'lazy';
  width: number;
  height: number;
}

const ArticleItemImage = ({
  src,
  alt,
  width,
  height,
  priority,
  loading,
  onError,
  ...rest
}: ArticleItemImageProps) => {
  const [srcUrl, setSrcUrl] = useState(src);

  const handleError = (e: SyntheticEvent<HTMLImageElement, Event>) => {
    onError?.(e);
    setSrcUrl(`${PATH.MEDIA_YOZM_IMAGE}/default_thumbnail_article.png`);
  };

  return (
    <Image
      src={srcUrl}
      alt={alt || ''}
      width={width}
      height={height}
      priority={priority}
      loading={loading}
      onError={handleError}
      {...rest}
    />
  );
};

export default ArticleItemImage;
